import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d6a2351"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-cen rel viewport" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "abs-wrap"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]

import { ref } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const requireComponent = require.context(
  '@/assets/image/campaign',
  false,
  /\.(jpg|png)$/
)
const list:any = {}

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
  const [key, w, h] = componentName.split('_')
  list[key] = { w: w ? Number(w) / 2 + 'px' : '', h: h ? Number(h) / 2 + 'px' : '', src: componentConfig }
})

const plugin = ref([
  [require('@/assets/image/campaign/plugin/btn1.png'), '', 150 + 150, 223, 280, 60],
  [require('@/assets/image/campaign/plugin/btn2.png'), '', 290 + 150, 684, 320, 60]
])
const route = useRoute()
// console.log(list)
// console.log(route)
// console.log(route.params.name)
const img = list[String(route.params.name)]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      referrerPolicy: "no-referrer",
      src: _unref(img).src,
      alt: "",
      style: _normalizeStyle({width:_unref(img).w,height:_unref(img).h})
    }, null, 12, _hoisted_2),
    (_ctx.$route.params.name === 'plugin')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plugin.value, (v, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "goods pbtn",
              style: _normalizeStyle({
          left: v[2] + 'px',
          top: v[3] + 'px',
        })
            }, [
              _createElementVNode("a", {
                target: "_blank",
                href: 'https://chrome.google.com/webstore/detail/kaeru%E3%83%84%E3%83%BC%E3%83%ABthe%E7%9B%B4%E8%A1%8C%E4%BE%BF/cbdgkflbadceflcbbogjkldbnjddnhbl?hl=ja'
          
              }, [
                _createElementVNode("img", {
                  referrerPolicy: "no-referrer",
                  src: v[0],
                  alt: "",
                  style: _normalizeStyle({
            width: v[4]+'px',
            height:v[5]+'px'
          })
                }, null, 12, _hoisted_5)
              ], 8, _hoisted_4)
            ], 4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})